import { type IUserTenantAccess } from '@inpart-io/devtools-iap';
import { RECEIVE_DATA_OBJECTS, REMOVE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type MutationTree } from 'vuex';

import { type IUserTenantAccessState } from './types';

export const mutations: MutationTree<IUserTenantAccessState> = {
    [RECEIVE_DATA_OBJECTS](_state: IUserTenantAccessState, { dataObjectList }: { dataObjectList: IUserTenantAccess[] }) {
        for (const dataObject of dataObjectList) {
            _state.dataObjectList.set(dataObject.dobjId, Object.assign({}, _state.dataObjectList.get(dataObject.dobjId), dataObject));
            if (dataObject.user instanceof Object) {
                _state.byUser.set(dataObject.user.dobjId, dataObject.dobjId);
            } else {
                _state.byUser.set(dataObject.user, dataObject.dobjId);
            }
        }
    },

    [REMOVE_DATA_OBJECTS](_state: IUserTenantAccessState, { dobjId }: { dobjId: number }) {
        if (_state.dataObjectList.has(dobjId)) {
            const uta = _state.dataObjectList.get(dobjId);
            if (uta.user instanceof Object) {
                _state.byUser.delete(uta.user.dobjId);
            } else {
                _state.byUser.delete(uta.user);
            }
        }
        _state.dataObjectList.delete(dobjId);
    }
};
